
/* ============================== src/components/ProjectProgress.jsx ============================== */
// src/components/ProjectProgress.jsx
import { FactPlan } from "./FactPlan";
import { getProjectColor } from "../utils/projectHelpers";

/**
 * Прогресс-бар проекта: тонкая обёртка над FactPlan.
 *
 * Оставлен отдельным компонентом (а не заменён прямым вызовом FactPlan
 * в ProjectCard), потому что резолвер цвета - getProjectColor - должен
 * жить в одной точке. Правило «часы проекта окрашены в цвет приоритета
 * проекта» меняется здесь, не трогая FactPlan.
 */
export function ProjectProgress({ project, fact }) {
  return (
    <FactPlan
      fact={fact}
      plan={project?.plannedHours}
      color={getProjectColor(project)}
    />
  );
}

export default ProjectProgress;
